import {DateUtils} from '@wallaby-ui/core';
import {MerieSchema, TableSorting, TablePaging, ShortcutEnum} from '@wallaby-ui/document';

export type InterventionOverviewReportFilter = MerieSchema.components['schemas']['InterventionOverviewReportFilter'] & {
  floatingShortcutName?: ShortcutEnum | null;
};
export type InterventionOverviewReportFilterItemType = MerieSchema.components['schemas']['InterventionOverviewReportFilter']['itemType'];
export type InterventionOverviewReportFilterAggregationType =
  MerieSchema.components['schemas']['InterventionOverviewReportFilter']['measureType'];
export type InterventionOverviewReportFilterDepartmentDetailType = 'DEPARTMENT' | 'UNIT';
export type RowType = MerieSchema.components['schemas']['InterventionsOverviewReportResultDto'];
export type RowTypeWithTotal = RowType & {isTotalRow?: boolean};
export type ChartDataType = MerieSchema.components['schemas']['InterventionsOverviewReportChartsResultDto'] & {
  measureCountLow?: number;
  measureCountLowPer1000HospDays?: number;
  measureCountMedium?: number;
  measureCountMediumPer1000HospDays?: number;
  measureCountHigh?: number;
  measureCountHighPer1000HospDays?: number;
};

export type FiltersData = {
  report: InterventionOverviewReportFilter;
  reportTableSorting: TableSorting;
  reportTablePaging: TablePaging;
  savedFiltersOpen: boolean;
};

export type ChartType = 'absolute' | 'caredays';
export enum ReportType {
  NETWORK = 'NETWORK',
  DEPARTMENT = 'DEPARTMENT',
}

export const FILTER_TABLE_CHART_LAYOUT_SPLIT_CONFIG = (layoutId: string) => [
  {
    sizes: [232, 384, 384],
    minSize: [50, 100, 100],
    layoutId,
  },
];

export const FILTER_DEPARTMENT_TABLE_CHART_LAYOUT_SPLIT_CONFIG = (layoutId: string) => [
  {
    sizes: [133, 136, 326, 326, 326, 326, 326],
    minSize: [50, 50, 50, 50, 50, 50, 50],
    layoutId,
  },
];

export const HOSPITAL_CHARTS_LAYOUT_SPLIT_CONFIG = (layoutId: string) => [
  {
    sizes: [500, 500],
    minSize: [100, 100],
    layoutId,
  },
];

export const CHARTS_LAYOUT_SPLIT_CONFIG = (layoutId: string) => [
  {
    sizes: [600, 400],
    minSize: [100, 100],
    layoutId,
  },
];

export const DEFAULT_HOSPITAL_NETWORK_REPORT_FILTERS: InterventionOverviewReportFilter = (() => {
  const [startOfLastMonth, endOfLastMonth] = DateUtils.lastCompletedMonth();
  return {
    dateFrom: startOfLastMonth,
    dateTo: endOfLastMonth,
    floatingShortcutName: ShortcutEnum.PREVIOUS_MONTH,
    measureType: 'ALL',
    itemType: 'PR',
    organizationLevelType: 'HOSPITAL',
    organizationId: undefined,
  };
})();

export const DEFAULT_HOSPITAL_REPORT_FILTERS = (organizationId: number | undefined) => {
  const [startOfLastMonth, endOfLastMonth] = DateUtils.lastCompletedMonth();
  return {
    dateFrom: startOfLastMonth,
    dateTo: endOfLastMonth,
    floatingShortcutName: ShortcutEnum.PREVIOUS_MONTH,
    measureType: 'ALL',
    itemType: 'PR',
    organizationLevelType: 'PARENT_DEPARTMENT',
    organizationId,
  } as InterventionOverviewReportFilter;
};

export const DEFAULT_HOSPITAL_NETWORK_REPORT_SORTING: TableSorting = {
  field: 'measureCount',
  direction: 'desc',
};

export const DEFAULT_HOSPITAL_NETWORK_REPORT_PAGING: TablePaging = {};

export const DEFAULT_HOSPITAL_REPORT_SORTING: TableSorting = {
  field: 'measureCount',
  direction: 'desc',
};

export const DEFAULT_HOSPITAL_REPORT_PAGING: TablePaging = {};

export const CHART_COLORS = [
  {
    color: '#FFB3B8',
    label: 'hospital.network.report.charts.absolute.legend.high',
  },
  {
    color: '#FDDC69',
    label: 'hospital.network.report.charts.absolute.legend.medium',
  },
  {
    color: '#A7F0BA',
    label: 'hospital.network.report.charts.absolute.legend.low',
  },
];

export const CHART_LEGEND_BACKGROUND = '--dlThemeGray-50';
export const CHART_ELLIPSIS_MAX_LENGTH = 15;
